import { useEffect, useState, useCallback } from 'react';
import { getTsMinutes } from '../screens/Live/LiveHelpers';
import { format, FORMAT_TIME, now } from '../helpers/DateTimeHelper';

export default function useCurrentPositionAndTime({ ended, startingTs, totalMinutes }) {
  const [minutes, setMinutes] = useState(getTsMinutes());
  const [currentTime, setCurrentTime] = useState(format(now(), FORMAT_TIME));

  const getMinutesElapsed = useCallback(minutes => minutes - Math.floor(startingTs / 60), [
    startingTs,
  ]);
  const minutesElapsed = getMinutesElapsed(minutes);
  const currentPosition = Math.floor(100 * (minutesElapsed / totalMinutes));

  useEffect(() => {
    const interval = setInterval(() => {
      const newMinutes = getTsMinutes();
      const minutesElapsed = getMinutesElapsed(newMinutes);
      if (minutes !== newMinutes) {
        if (ended && minutesElapsed >= totalMinutes) {
          ended();
        }
        setMinutes(newMinutes);
        setCurrentTime(format(now(), FORMAT_TIME));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [getMinutesElapsed, totalMinutes, startingTs, ended, minutes, currentTime]);

  return {
    currentPosition,
    currentTime,
  };
}
